'use strict';

const getPropertyValuesOfOppositeSides = (
  elementStyles,
  propertyName,
  dimensionName
) => {
  let sides;
  switch (dimensionName) {
    case 'Height':
      sides = ['top', 'bottom'];
      break;
    case 'Width':
      sides = ['left', 'right'];
      break;
    default:
      return 0;
  }

  return sides.reduce(
    (totalLength, side) =>
      (totalLength += parseInt(
        elementStyles.getPropertyValue(`${propertyName}-${side}`) || 0
      )),
    0
  );
};

/*
  DEVNOTE:
    - the default of this function gets you the "outer" height/width of the element.
    - border/margin/padding options are provided to get you the slice of the
      box model you are looking for.
    - when using, consider changing the options to avoid a "getComputedStyle" call,
      which forces a reflow

  TODOS:
    - add option to check scrollHeight instead
    - cache getComputedStyle on an element
*/

const getDimension = (
  $element,
  { border = true, margin = true, padding = true } = {},
  dimensionName
) => {
  let dimensionVal = $element[(border ? 'offset' : 'client') + dimensionName];
  let elementStyles;

  if (!padding) {
    elementStyles = window.getComputedStyle($element);
    dimensionVal -= getPropertyValuesOfOppositeSides(
      elementStyles,
      'padding',
      dimensionName
    );
  }

  if (margin) {
    if (!elementStyles) {
      elementStyles = window.getComputedStyle($element);
    }
    dimensionVal += getPropertyValuesOfOppositeSides(
      elementStyles,
      'margin',
      dimensionName
    );
  }

  return dimensionVal;
};

const getWidth = ($element, options) =>
  getDimension($element, options, 'Width');

const getHeight = ($element, options) =>
  getDimension($element, options, 'Height');

module.exports = { getWidth, getHeight };
